<template>
  <div class="theme-demo-container">
    <h1 class="page-title">字体展示</h1>

    <div class="font-card">
      <h2 class="card-title">默认字体</h2>
      <div class="font-sample">
        <div class="sample-item">zh-字体 1234567890</div>
        <div class="sample-item">en-Font abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890</div>
      </div>
    </div>

    <div class="font-card">
      <h2 class="card-title">主题-默认</h2>
      <div class="font-sample">
        <div class="font sample-item">zh-字体 1234567890</div>
        <div class="font sample-item">en-Font abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890</div>
      </div>
    </div>

    <div class="font-card">
      <h2 class="card-title">主题-加粗</h2>
      <div class="font-sample">
        <div class="font bold sample-item">zh-字体 1234567890</div>
        <div class="font bold sample-item">en-Font abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890</div>
      </div>
    </div>

    <div class="font-card">
      <h2 class="card-title">主题-semibold</h2>
      <div class="font-sample">
        <div class="font semi-bold sample-item">zh-字体 1234567890</div>
        <div class="font semi-bold sample-item">en-Font abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890</div>
      </div>
    </div>

    <div class="font-card">
      <h2 class="card-title">业务场景实例</h2>
      <div class="font"><br> Open Sans-Regular： Order ID: 62287900000000000 <br> website: www.shopify.comwww.shopify.
        comopify.com</div>
      <div class="bold" style="font-size: 36px;">Open Sans-Bold： 22.85 USD</div>

      <div class="semi-bold" style="color: #FF7D00;">倒计时： 00:03:00</div>
    </div>

    <div class="theme-color">系统主题色 品牌色||默认色</div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.theme-color {
  color: var(--brand-color);
}

.theme-demo-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-title {
  text-align: center;
  margin-bottom: 32px;
  color: #333;
  font-size: 28px;
}

.font-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

.card-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.font-sample {
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
}

.sample-item {
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }
}

.font {
  font-family: Open Sans regular;
}

.bold {
  font-family: Open Sans bold;
}

.semi-bold {
  font-family: Open Sans semiBold;
}
</style>
